import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';

@Component({
  selector: 'app-individualform',
  templateUrl: './individualform.component.html',
  styleUrls: ['./individualform.component.scss']
})
export class IndividualformComponent implements OnInit {

  aboutForm!: FormGroup;
  countries: any = [];
  states: any = [];
  cities: any = [];
  countriesCode: any = []
  organizer: any
  // error:any

  submitted = false;
  error: string | null = null;
  public formfillNext: boolean = false;
  businessTypes: any = [];

  isEditMode = false;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _ds: DataService,
    private enc: EncryptionService,
    private router: Router,
    private organizerSession: OrganizerSessionService
  ) {
    let data = localStorage.getItem('user');
    this.organizer = data ? JSON.parse(data) : null;
  }

  ngOnInit(): void {
    this.aboutForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      brand: ['', [Validators.required]],
      // businessType: [null, [Validators.required]],
      email: [{ value: this.organizer.email, disabled: true }],
      countryCode: [null, [Validators.required]],
      // mobile: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(6),
      Validators.maxLength(15)]],
      country: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
      website: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(https?:\/\/)(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/)
        ]
      ]
    });
    this.getAllcountries();
    this.getAllcountryCode();
    // this.getAllbusinessType();

    // 🔥 CountryCode → Country sync
    this.aboutForm.get('countryCode')?.valueChanges.subscribe(code => {

      if (this.isEditMode) return;

      const selectedCode = this.countriesCode.find(
        (c: any) => c.phonecode == code
      );

      if (!selectedCode) return;

      const matchedCountry = this.countries.find(
        (c: any) => c.id == selectedCode.id
      );

      if (!matchedCountry) return;

      this.aboutForm.patchValue(
        {
          country: matchedCountry.name,
          state: null,
          city: null
        },
        { emitEvent: false }
      );

      this.states = [];
      this.cities = [];

      this.getAllstates(matchedCountry.id);
    });



    // 🔥 Country → CountryCode sync
    this.aboutForm.get('country')?.valueChanges.subscribe(countryName => {
      if (this.isEditMode) return;
      const selectedCountry = this.countries.find(
        (c: any) => c.name == countryName
      );

      if (!selectedCountry) return;

      const matchedCode = this.countriesCode.find(
        (c: any) => c.id == selectedCountry.id
      );

      if (!matchedCode) return;

      this.aboutForm.patchValue(
        {
          countryCode: matchedCode.phonecode,
          state: null,
          city: null
        },
        { emitEvent: false }
      );

      this.states = [];
      this.cities = [];

      this.getAllstates(selectedCountry.id);
    });



    // 🔥 State → City load
    this.aboutForm.get('state')?.valueChanges.subscribe(stateName => {
      if (this.isEditMode) return;
      const selectedState = this.states.find(
        (s: any) => s.name == stateName
      );

      if (!selectedState) return;

      this.aboutForm.patchValue(
        { city: null },
        { emitEvent: false }
      );

      this.cities = [];

      this.getAllcities(selectedState.id);
    });


    this.route.queryParams.subscribe(params => {
      const id = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/individual',
        this.router
      );
      if (id == null) return;
      this.isEditMode = true;
      this.formfillNext = true

      this._ds.getUniqueUserData(id).subscribe((res: any) => {
        const allData = this.enc.decrypt(res.data);

        const selectedNames = allData.organizer;
        console.log(selectedNames)
        const cleanNumber = allData.organizer.phone.replace('+', '');
        const parts = cleanNumber.split(' ');

        // 2. Variables mein store karo
        const countryCode = parts[0]; // Isme "+91" aayega
        const mobileNumber = parts[1]; // Isme "9045444416" aayega


        setTimeout(() => {
          this.aboutForm.patchValue({
            firstName: allData.organizer.first_name,
            lastName: allData.organizer.last_name,
            countryCode: countryCode,
            mobile: mobileNumber,

            email: allData.organizer.email,
            brand: allData.organizer.company_name,
            // designation: allData.organizer.designation,
            // organization_name: allData.organizer.company_name,
            website: allData.organizer.website,
            // businessType: allData.organizer.business_type,
            country: allData.organizer.country,
            state: allData.organizer.state,
            city: allData.organizer.city,

          });
          Object.keys(this.aboutForm.controls).forEach(key => {
            this.aboutForm.get(key)?.disable();
          });
          this.isEditMode = false;
        }, 500);
      });

    });


  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getAllcountries() {
    this._ds.allCountry().subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.countries = decryptedData.data;
      console.log(this.countries)
    })
  }

  numberOnly(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;

  // Allow only 0-9
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}

  //  getAllcountryCode() {
  //   this._ds.allCountryCode().subscribe((res) => {
  //     // this.countries = res
  //     const decryptedData = this.enc.decrypt(res.data);
  //     this.countriesCode = decryptedData.data;
  //     console.log('✅ Decrypted response:', decryptedData);
  //   })
  // }

  getAllcountryCode() {
    this._ds.allCountryCode().subscribe((res) => {
      const decryptedData = this.enc.decrypt(res.data);
      this.countriesCode = decryptedData.data;
      console.log(this.countriesCode)
      // 🇮🇳 India ko by default select karo
      const india = this.countriesCode.find(
        (c: any) => c.phonecode === '91' || c.name === 'India'
      );

      if (india) {
        this.aboutForm.patchValue({
          countryCode: india.phonecode   // 👈 id set karni hai
        });
      }
    });
  }

  getAllbusinessType() {
    this._ds.allBusinessType().subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.businessTypes = decryptedData.data;
      console.log(this.businessTypes)
    })
  }


  onCountryChange(countryId: any) {
    console.log(countryId);
    this.getAllstates(countryId.id);
  }

  onStateChange(stateId: any) {
    this.getAllcities(stateId.id);
  }



  getAllcities(id: any) {
    this._ds.allCities(id).subscribe((res) => {

      const decryptedData = this.enc.decrypt(res.data);
      this.cities = decryptedData.data;
      console.log('✅ Decrypted response:', decryptedData);
    })
  }

  getAllstates(id: any) {
    this._ds.allState(id).subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.states = decryptedData.data;
      console.log('✅ Decrypted response:', decryptedData);
    })
  }



  submitForm() {
    this.submitted = true;

    if (this.aboutForm.invalid) {
      this.aboutForm.markAllAsTouched();
      console.log('❌ Form invalid, API call blocked');
      return;
    }

    const form = this.aboutForm.getRawValue(); // disabled email ke liye

    const payload = {
      organizer_type: 'individual',
      email: form.email,
      first_name: form.firstName,
      last_name: form.lastName,
      phone: `+${form.countryCode} ${form.mobile}`,
      organization_name: form.brand,
      website: form.website,
      business_type: 'individual',
      country: form.country,
      state: form.state,
      city: form.city,
    };

    this._ds.createOrganizer(payload).subscribe({
      next: (res) => {
        console.log('Organizer created (200)', res);

        if (res?.data) {
          const decryptedData = this.enc.decrypt(res.data);
          localStorage.setItem('organizer', JSON.stringify(decryptedData));
          if (decryptedData?.jwt_token) {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            user.jwt_token = decryptedData.jwt_token;
            localStorage.setItem('user', JSON.stringify(user));
            this._ds.getDiorToken();
          }
          this.router.navigate(['/event-information']);
        }
      },
      error: (err) => {
        if (err?.error?.data) {
          const decryptedData = this.enc.decrypt(err.error.data);
          this.error = decryptedData.error;
          setTimeout(() => (this.error = null), 5000);
        }
      }
    });
  }

  next() {
    const id = this.organizerSession.getSessionOrganizerId();
    if (id == null) return;
    this.router.navigate(['/event-information'], { queryParams: { id } });
  }

}